import { Component } from '@angular/core';

@Component({
  selector: 'mprd-available-settings-skeleton',
  templateUrl: './available-settings-skeleton.component.html',
  styleUrls: ['./available-settings-skeleton.component.css'],
})
export class AvailableSettingsSkeletonComponent {
  constructor() {}
}
